import {
  LOADING_COMPANY,
  LOAD_COMPANY,
  COMPANY_SAVE_REQUEST,
  COMPANY_SAVE_SUCCESS,
  FETCH_COMPANY_REQUEST,
  FETCH_COMPANY_REQUEST_SUCCESS,
} from "../types/company.types";

export interface ICompanyLocation {
  facility_name: ICompany["facility_name"];
  facility_tree: string;
}
export interface ICompany {
  facility_active: boolean;
  facility_address: string;
  facility_contact_email: string;
  facility_contact_number: string;
  facility_contact_person: string;
  facility_latlang: string;
  facility_name: string;
  facility_status: boolean;
  id: string;
  parent: null | ICompany["id"];
  facility_type: null | string;
}

export type companyStateType = {
  companies: null | ICompany[];
  company: null | ICompany;
  total: number;
  current: number;
  loading: boolean;
  save: boolean;
};

const initialState: companyStateType = {
  companies: null,
  company: null,
  total: 0,
  current: 1,
  loading: false,
  save: false,
};

export default function wardReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_COMPANY:
      return {
        loading: false,
        companies: action.payload.results,
        total: action.payload.count,
        current: action.payload.current,
      };
    case LOADING_COMPANY:
    case FETCH_COMPANY_REQUEST:
      return {
        ...state,
        company: null,
        loading: true,
      };
    case COMPANY_SAVE_REQUEST:
      return {
        ...state,
        save: false,
      };
    case COMPANY_SAVE_SUCCESS:
      return {
        ...state,
        save: true,
        company: null,
      };
    case FETCH_COMPANY_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.payload,
      };
    default:
      return state;
  }
}
